import * as baseApi from '@/api/base'

const state = {
	countries: [],   //国家
	provinces: [],   //省
	cities: [],      //市
	districts: [],    //区
	towns:[],     //县
	countys:[] //镇
}
const getters = {
	countries: state => state.countries,
	provinces: state => state.provinces,
	cities: state => state.cities,
	districts: state => state.districts,
	towns: state => state.towns,
	countys: state => state.countys
}
const actions = {
	// 获取所有的国家
	GetAllCountries({commit},data){
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaListByLevel(data.level).then(response => {
				commit('GET_ALL_COUNTRIES', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},
	GetAllProvinces({commit}, data){
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaList(data).then(response => {
				commit('GET_ALL_PROVINCES', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},
	GetAllCities({commit}, data){
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaList(data).then(response => {
				commit('GET_ALL_CITIES', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},
	GetAllDistricts({commit}, data) {
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaList(data).then(response => {
				commit('GET_ALL_DISTRICTS', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},
	GetAllTowns({commit}, data) {
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaList(data).then(response => {
				commit('GET_ALL_TOWNS', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},
	GetAllCountys({commit}, data) {
		return new Promise( (resolve, reject) =>{
			baseApi.searchAreaList(data).then(response => {
				commit('GET_ALL_COUNTYS', response)
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	}
}
const mutations = {
	GET_ALL_COUNTRIES: (state, countries) => {
		state.countries = countries
	},
	GET_ALL_PROVINCES: (state, provinces) => {
		state.provinces = provinces
	},
	GET_ALL_CITIES: (state, cities) => {
		state.cities = cities
	},
	GET_ALL_DISTRICTS: (state, districts) => {
		state.districts = districts
	},
	GET_ALL_TOWNS: (state, towns) => {
		state.towns = towns
	},
	GET_ALL_COUNTYS: (state, countys) => {
		state.countys = countys
	}
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/region.js